<template>
    <div class="auth-layout">
        <RouterView />
    </div>
</template>

<style src="./style.scss" lang="scss"/>